// extracted by mini-css-extract-plugin
export default {"container":"wC-z","dimension":"xC-z","dimensionLabels":"yC-z"};